import React, {useEffect, useState} from 'react'
import { Button, Flowbite, TextInput, Timeline, Avatar } from 'flowbite-react';
import { getUserInfo } from '../firebase/FirebaseManagement';
import { timeLineTheme } from './themes';
import {BiCurrentLocation} from 'react-icons/bi'
import {MdLocationOn} from 'react-icons/md'

export default function RideCard(props) {
    const rideDetails = props.rideDetails;

    const [driverInfo, setDriverInfo] = useState(null);

    useEffect(() => {
        const fetchDriverInfo = async () => {
          const driverInfo = await getUserInfo(rideDetails.driver);
          setDriverInfo(driverInfo);
        };
      
      
        fetchDriverInfo();
        
    },[])

  return (
    <div className='!gap-4 !p-[30px] box-container'>
        <Avatar
        img={driverInfo?.file}
        rounded
        className='!justify-start'
        >
        <div className="space-y-1 font-medium dark:text-white">
            {driverInfo?.firstName} {driverInfo?.lastName}
        </div>
        </Avatar>
        <Flowbite theme={{theme:timeLineTheme}}>
            <Timeline className='ml-4'>
                <Timeline.Item>
                    <Timeline.Point icon={BiCurrentLocation}/>
                    <Timeline.Content>
                        <Timeline.Time>
                            Start Location
                        </Timeline.Time>
                        <Timeline.Title className='font-normal'>
                            {rideDetails.departure}
                        </Timeline.Title>
                    </Timeline.Content>
                </Timeline.Item>
                <Timeline.Item>
                    <Timeline.Point icon={MdLocationOn}/>
                    <Timeline.Content>
                        <Timeline.Time>
                            Destination
                        </Timeline.Time>
                        <Timeline.Title className='font-normal'>
                            {rideDetails.destination}
                        </Timeline.Title>
                    </Timeline.Content>
                </Timeline.Item>
            </Timeline>
        </Flowbite>
        <div className='flex justify-between'>
            <div>
                <p className='font-bold text-gray-900 text-sm'>Date & Time</p>
                <p>{new Date(rideDetails.date.seconds * 1000).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}{" "}{rideDetails.time}</p>
            </div>
            <div>
                <p className='font-bold text-gray-900 text-sm'>Price</p>
                <p>${rideDetails.price}</p>
            </div>
            <div>
                <p className='font-bold text-gray-900 text-sm'>Seats</p>
                <p>{rideDetails.seats - rideDetails.passengers.length}{"/"}{rideDetails.seats}</p>
            </div>
        </div>
        
    </div>
  )
}
